<script lang="ts" setup>
import underReviewIcon from '@images/svg/under-review.svg'

const isDialogVerifyProfile = defineModel({
    type: Boolean,
    default: false
})

const { t } = useI18n()
</script>

<template>
    <VDialog v-model="isDialogVerifyProfile" width="500">
        <!-- Dialog Content -->
        <VCard>
            <DialogCloseBtn
                variant="text"
                size="default"
                @click="isDialogVerifyProfile = false"
            />

            <VCardText class="pt-5">
                <div class="text-center mb-6 mt-10">
                    <Component :is="underReviewIcon" />
                    <h4 class="text-h4 mb-2">{{ t('Your Account is Under Review') }}</h4>
                    <p>
                        {{
                            t(
                                'Your account is currently under review by our team. Please wait for further updates.'
                            )
                        }}
                    </p>
                    <VBtn color="primary" @click="isDialogVerifyProfile = false"
                        >{{ t("I'm Understand") }}</VBtn
                    >
                </div>
            </VCardText>
        </VCard>
    </VDialog>
</template>
